export const getMetricsCount = campaigns =>
  campaigns.reduce((acc, { metrics }) => {
    metrics.forEach(metric => {
      const metricName = metric.label
        ? metric.label.split(' ').join('')
        : metric.name.split(' ').join('')

      if (metric.costPerMetric) {
        acc[`costPer${metricName}Metric`] =
          (acc[`costPer${metricName}Metric`]
            ? acc[`costPer${metricName}Metric`]
            : 0) + 1
      }
      if (metric.conversionRate) {
        acc[`CVR${metricName}Metric`] =
          (acc[`CVR${metricName}Metric`] ? acc[`CVR${metricName}Metric`] : 0) +
          1
      }
    })

    return acc
  }, {})

const calculateMetricsTotal = (metricsCount, metric, acc) => {
  const metricName = metric.label
    ? metric.label.split(' ').join('')
    : metric.name.split(' ').join('')
  acc[`total${metricName}`] =
    (acc[`total${metricName}`] ? acc[`total${metricName}`] : 0) +
    (metric.metricValue ? metric.metricValue : 0)
  acc[`totalCostPer${metricName}`] =
    (acc[`totalCostPer${metricName}`] ? acc[`totalCostPer${metricName}`] : 0) +
    (metric.costPerMetric ? metric.costPerMetric : 0)
  acc[`total${metricName}CVR`] =
    (acc[`total${metricName}CVR`] ? acc[`total${metricName}CVR`] : 0) +
    (metric.conversionRate
      ? metric.conversionRate / metricsCount[`CVR${metricName}Metric`]
      : 0)
  return acc
}

export const setCampaignsTotals = (campaign, acc, metricsCount) => {
  const {
    flyersDistributed,
    costs: {
      printingCostForMission = 0,
      permitCostForMission = 0,
      distributionCost = 0,
      hardCosts = 0,
      bonusCostForMission = 0,
    },
    scans,
    metrics,
    missions,
  } = campaign

  acc.totalFlyersDistributed += flyersDistributed ? flyersDistributed : 0
  acc.totalHardCosts += hardCosts ? hardCosts : 0
  acc.totalScans += scans ? scans : 0
  acc.totalPrintingCost += printingCostForMission ? printingCostForMission : 0
  acc.totalPermitCost += permitCostForMission ? permitCostForMission : 0
  acc.totalDistributionCost += distributionCost ? distributionCost : 0
  acc.totalBonusCost += bonusCostForMission ? bonusCostForMission : 0
  acc.totalMissionsCount += missions.length ? missions.length : 0

  if (metrics.length) {
    metrics.forEach(metric => {
      calculateMetricsTotal(metricsCount, metric, acc)
    })
  }
  return acc
}
